export const IMPERFECT_THEME_BODY_CLASS = 'theme-imperfectfoods';
export const MISFITS_THEME_BODY_CLASS = 'theme-misfitsmarket';
export const MISFITS_THEME_DOMAIN = 'misfitsmarket';
export const IMPERFECT_THEME_DOMAIN = 'imperfectfoods';
